export default {"src":"/_next/static/media/security_pc1.df089823.svg","height":60,"width":60};